import { render } from "./PlaidLink.vue?vue&type=template&id=16127c66"
import script from "./PlaidLink.vue?vue&type=script&lang=js"
export * from "./PlaidLink.vue?vue&type=script&lang=js"

import exportComponent from "/data/front/cryptogold-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__